import { render, staticRenderFns } from "./MapLegendContainer.vue?vue&type=template&id=5f4c1aa0&scoped=true&"
import script from "./MapLegendContainer.vue?vue&type=script&lang=js&"
export * from "./MapLegendContainer.vue?vue&type=script&lang=js&"
import style0 from "./MapLegendContainer.vue?vue&type=style&index=0&id=5f4c1aa0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4c1aa0",
  null
  
)

export default component.exports